import { render, staticRenderFns } from "./stopservice.vue?vue&type=template&id=0251b728&scoped=true&"
import script from "./stopservice.vue?vue&type=script&lang=js&"
export * from "./stopservice.vue?vue&type=script&lang=js&"
import style0 from "./stopservice.vue?vue&type=style&index=0&id=0251b728&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251b728",
  null
  
)

export default component.exports